import React from 'react';

import Text, {Props as TextProps} from '../Text/Text.react';

import {CommonTextProps} from './types';

export interface Props extends CommonTextProps {
  color?: TextProps['color'];
  isBold?: boolean;
}

export default function MenuListItemCategoryText({
  className,
  children,
  size = 'm',
  isBold = true,
  ...rest
}: Props) {
  return (
    <Text className={className} bold={isBold} size={size} color='tertiary' {...rest}>
      {children}
    </Text>
  );
}
